import type { ReadonlyHeaders } from 'next/dist/server/web/spec-extension/adapters/headers';
import type { SearchParams } from '@/server/searchParams';
import type { URLParameters } from '@/app/common/urlParameters.ts';
import getSearchParams from '@/app/components/search/common/getSearchParams.ts';
import { BASE_PATH } from '@/app/components/search/utils/path.ts';
import { canUseDOM } from '@/app/common/utils/canUseDOM';

// Timeout value used for MemSearch and StaticDB
export const DEFAULT_FETCH_TIMEOUT = 12000;

export const createQueryString = (searchParams: SearchParams): string =>
  Object.entries(searchParams)
    .map(([key, val]) => `${key}=${String(val).split(',').map(encodeURIComponent).join(',')}`)
    .join('&');

export const whenMultipleValuesTakeTheFirst = (val: string | string[] | undefined): string | undefined => {
  if (Array.isArray(val)) {
    return val.length > 0 ? val[0] : undefined;
  }
  return val;
};

export const updateQueryStringParam = (param: URLParameters, value: string) => {
  if (!canUseDOM) {
    return;
  }
  const searchParams = getSearchParams();
  const newSearchParams = { ...searchParams, [param]: value };
  window.history.replaceState(null, '', `?${createQueryString(newSearchParams)}`);
};

export const createIndexUrl = (queryString: string): string =>
  queryString ? `${BASE_PATH}?${queryString}` : BASE_PATH;

// TODO: Check/Improve this!
export const createRequestUrl = (headers: ReadonlyHeaders, searchParams: SearchParams) => {
  const proto = headers.get('x-forwarded-proto');
  const host = headers.get('x-forwarded-host');
  const queryString = createQueryString(searchParams);
  return `${proto}://${host}${queryString && '?'}${queryString}`;
};

export const substituteDomain = (url: string, newDomain: string): string => {
  const originalUrl = new URL(url);
  const domainUrl = new URL(newDomain);

  // Replace protocol, hostname, and port (if present)
  originalUrl.protocol = domainUrl.protocol;
  originalUrl.hostname = domainUrl.hostname;
  originalUrl.port = domainUrl.port;

  return originalUrl.toString();
};
